import { authAxios as axios } from "api-generate-types/src/axios";
import { config } from "../../../../../config";

export interface IAgencyPermission {
  name: string;
  id: number;
  agencyId: number;
  allowNudge: boolean;
  nudgeAllowed: boolean;
  allowSelfSuggest: boolean;
  suggestAllowed: boolean;
  performersReceiveBreakdownEmails: boolean;
}

export interface IUserResponse {
  forenames: string;
  id: string;
  name: string;
  portalGuid: string;
  role: string;
  surname: string;
  agencies: IAgencyPermission[];
}

export const getAgencies = async () => {
  try {
    const response = await axios.get<IUserResponse>(
      `${config.liteAgentApiUrl}/whoami`
    );

    return response.data.agencies;
  } catch (error) {
    return [];
  }
};
